module.exports = __webpack_public_path__ + "static/img/qualified.99585ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/修饰合成/修饰引物合成/qualified.png
// module id = Jw7A
// module chunks = 16